import { Component, DestroyRef, inject, ChangeDetectionStrategy } from "@angular/core";
import { ThemePalette } from "@angular/material/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { BehaviorSubject } from "rxjs";
import { LorenModalData } from "../../interfaces/loren-modal-data.interface";
import { LorenEntityFormModel } from "../../../loren-entity-form-card/interfaces/loren-entity-form-model.interface.ts";
import { FormFieldInteraction } from "../../../loren-entity-form-card/components/loren-entity-form-card/interfaces/form-field-interaction.interface";
import { LorenFormSubmission } from "../../../loren-entity-form-card/interfaces/loren-form-submission.interface";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "loren-dialog",
    templateUrl: "./loren-dialog.component.html",
    styleUrls: ["./loren-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenDialogComponent {
  data = inject<LorenModalData>(MAT_DIALOG_DATA);

  private readonly destroyRef = inject(DestroyRef);
  modalTitle: string;
  titleTranslationOptions: object;
  modalCloseBtnLabel: string;
  modalAcceptBtnColor: ThemePalette;
  modalAcceptBtnLabel: string;
  modalSubTitle: string;
  form: LorenEntityFormModel;

  private formFieldInteraction =
    new BehaviorSubject<FormFieldInteraction>(null);

  constructor() {
    const data = this.data;

    this.modalTitle = data.title;
    this.titleTranslationOptions = data.titleTranslationOptions;
    this.modalCloseBtnLabel = data.modalCloseBtnLabel;
    this.modalAcceptBtnLabel = data.modalAcceptBtnLabel;
    this.modalAcceptBtnColor = data.modalAcceptBtnColor ?? "primary";
    this.modalSubTitle = data.modalSubTitle;
    this.form = data.form;

    if (this.form) {
      this.form.formFieldInteraction = this.formFieldInteraction.asObservable();

      if (this.form.reloadForm) {
        this.form.reloadForm.pipe(
          takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => {
          this.form = Object.assign({}, data.form);
        });
      }
    }
  }

  handleSubmitForm(formSubmission: LorenFormSubmission) {
    this.form.formFields.forEach(
      (x) => (x.value = formSubmission.value[x.name])
    );
  }

  handleFormFieldInteraction($event: FormFieldInteraction) {
    this.formFieldInteraction.next($event);
  }
}
